export default function StatsGrid({ className = '', children, ...rest }) {
  // Merged, not spread over: a caller's className has to add to .stats-grid
  // rather than silently replace it and take the grid with it.
  return <div className={['stats-grid', className].filter(Boolean).join(' ')} {...rest}>{children}</div>;
}
